/**
 * Shared constants for the AWS Demo Platform.
 * Defines field length limits, URL validation patterns, and status values.
 */
/** Maximum character lengths for validated fields */
export const FIELD_LIMITS = {
    TITLE_MAX: 150,
    DESCRIPTION_MAX: 2000,
    PROJECT_NAME_MAX: 150,
    SEARCH_TERM_MAX: 100,
};
/**
 * Regex pattern for validating live demo URLs.
 * Requires https:// protocol with a syntactically valid domain name.
 */
export const LIVE_DEMO_URL_REGEX = /^https:\/\/[a-zA-Z0-9]([a-zA-Z0-9-]*[a-zA-Z0-9])?(\.[a-zA-Z]{2,})+(\/.*)?$/;
/** Valid demo statuses */
export const DEMO_STATUS = {
    ACTIVE: 'active',
    ARCHIVED: 'archived',
};
//# sourceMappingURL=constants.js.map